module.exports = __webpack_public_path__ + "static/media/portfolio1 (43).a83aee8b.jpeg";